module.exports = __webpack_public_path__ + "static/img/xb.bb5e7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/xb.jpg
// module id = 6KPs
// module chunks = 49